/**
 * Centralized risk label mapping — single source of truth.
 * Every UI surface must import from here. No inline ternaries.
 */

export const RISK_LABELS: Record<string, string> = {
  GREEN: 'LOW RISK INDICATORS',
  YELLOW: 'MODERATE RISK INDICATORS',
  RED: 'HIGH RISK INDICATORS',
  UNKNOWN: 'UNKNOWN RISK',
};

export const RISK_HEADLINES: Record<string, string> = {
  GREEN: 'No significant risk indicators detected',
  YELLOW: 'Multiple caution indicators detected',
  RED: 'Multiple risk indicators detected',
  UNKNOWN: 'Insufficient intelligence data',
};

export function getRiskLabel(riskLevel: string | undefined | null): string {
  if (!riskLevel) return RISK_LABELS.UNKNOWN;
  return RISK_LABELS[riskLevel] ?? RISK_LABELS.UNKNOWN;
}
